import React from 'react';

import EditCancellationForm from '../../../../components/siteadmin/CancellationPolicy/EditCancellation/EditCancellationForm';
import NotFound from '../../../notFound/NotFound';
import Loader from '../../../../components/Loader/Loader';

import { getCancellationPolicy } from '../../../../lib/graphql';

import { useQuery } from '@apollo/client';


const EditCancellationPolicy = (props) => {

    const { data, loading } = useQuery(getCancellationPolicy, {
        variables: {
            id: props.id,
        },
        fetchPolicy: 'network-only',
        ssr: false
    })

    const dynamicPolicyContents = !loading && data?.getCancellationPolicy?.result?.dynamicCancellationContent;
    const result = !loading && data?.getCancellationPolicy?.result;

    let dynamicCancellationData = [], initialValues = {}
    if (!loading && dynamicPolicyContents?.length > 0) {
        dynamicPolicyContents.forEach((item) => {
            dynamicCancellationData.push({
                language: item?.language,
                policyName: item?.policyName,
                policyContent: item?.policyContent,
                subTitle: item?.subTitle,
                subContent: item?.subContent,
                content1: item?.content1,
                content2: item?.content2,
                content3: item?.content3,
                priorDays: item?.priorDays,
            })
        })
    } else {
        dynamicCancellationData.push({
            language: 'en',
            policyName: result?.policyName,
            policyContent: result?.policyContent,
            subTitle: result?.subTitle,
            subContent: result?.subContent,
            content1: result?.content1,
            content2: result?.content2,
            content3: result?.content3,
            priorDays: result?.priorDays,
        })
    }
    const feeFields = [
        'id', 'priorDays',
        'accommodationPriorCheckIn', 'accommodationBeforeCheckIn', 'accommodationDuringCheckIn',
        'guestFeePriorCheckIn', 'guestFeeBeforeCheckIn', 'guestFeeDuringCheckIn',
        'hostFeePriorCheckIn', 'hostFeeBeforeCheckIn', 'hostFeeDuringCheckIn',
    ];
    initialValues = {
        dynamicCancellationPolicyContent: dynamicCancellationData,
        ...Object.fromEntries(feeFields.map(field => [field, result[field] ?? null])),
    }


    if (loading) {
        return <Loader type={"text"} />;

    } else if (!data || !data?.getCancellationPolicy?.result) {
        return <NotFound />
    }
    else {
        return <EditCancellationForm
            initialValues={initialValues}

        />
    }
}

export default EditCancellationPolicy;